import { FlatInspirationItem, InspirationItem } from './types.ts';

export const transformInspirationItemResponse = (rawResult: InspirationItem): FlatInspirationItem => {
	const { id, department, imageUrl, attributes } = rawResult;
	const { styles, colors, patterns, fitsTop, fitsBottom, highlights, heels } = attributes || {};

	return {
		id,
		department: department ?? 'Womenswear',
		imageUrl: imageUrl ?? '',
		styles: styles ?? [''],
		colors: colors ?? [''],
		patterns: patterns ?? [''],
		fitsTop: fitsTop ?? [''],
		fitsBottom: fitsBottom ?? [''],
		highlights: highlights ?? [''],
		heels: heels ?? ''
	};
};
